import {BenjiKIV} from "../../BenjiKIV";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {BenjiKIVStatics} from "../../BenjiKIVStatics";
import {SimpleReelModelState} from "../../../core/reel/ReelInterfaces";
import {SimpleReelModelEventData} from "../../reels/BenjiKIVReelModel";
import {gsap} from "gsap";
import {BenjiKIVSpinResultRunner} from "../base/BenjiKIVSpinResultRunner";

/**
 * Created by Jerker Nord on 2022-12-02.
 */

export class BenjiKIVNormalResultRunner extends BenjiKIVSpinResultRunner {

    protected doStop():void {
        this._controller.setSkipCallback(() => this.skip())
        this._stoppedReels = [false, false, false, false, false];
        this._reelStoppedAnimations = [this._emptyTL, this._emptyTL, this._emptyTL, this._emptyTL, this._emptyTL];
        const isFastSpin:boolean = BenjiKIV.apiPlugin.settings.get(APISetting.FAST_SPIN, false);

        this._tl = gsap.timeline();

        for(let i:number = 0; i < BenjiKIV.model.gameData.reels.length; i++) {
            let stopDelay:number = isFastSpin ? BenjiKIVStatics.reelStopDelayFastSpin[i] : BenjiKIVStatics.reelStopDelayNormal[i];
            const reelData:string[] = BenjiKIV.model.gameData.reels[i];
            const reelStopAnimation:gsap.core.Timeline = gsap.timeline();

            if(BenjiKIV.model.badOutcomeReels[i] == true) {
                stopDelay = isFastSpin ? BenjiKIVStatics.reelStopDelayBadOutcomeFast[i] : BenjiKIVStatics.reelStopDelayBadOutcomeNormal[i];
            }

            if(BenjiKIV.model.goodOutcomeReels[i] == true) {
                stopDelay += 0.3;
            }

            if(BenjiKIV.model.diceAnticipationReels[i] == true) {
                if(BenjiKIV.model.isLuckyDrawBet == true) {
                    stopDelay += BenjiKIVStatics.DICE_ANTICIPATION_DELAY_LUCKY_DRAW;
                } else {
                    stopDelay += isFastSpin ? BenjiKIVStatics.DICE_ANTICIPATION_DELAY_FAST : BenjiKIVStatics.DICE_ANTICIPATION_DELAY_NORMAL;
                }
            }

            if(BenjiKIV.model.deadPresidentAnticipationReels[i] == true && BenjiKIV.model.diceAnticipationReels[i] == false) {
                stopDelay += isFastSpin ? BenjiKIVStatics.DEAD_ANTICIPATION_DELAY_FAST : BenjiKIVStatics.DEAD_ANTICIPATION_DELAY_NORMAL;
            }

            //prevents useless skips when last reel has started its stop anyway.
            if(i == 4) {
                reelStopAnimation.add(() => {this._controller.setSkipCallback()});
            }

            //Do show enhancer view result + ring girl
            if(BenjiKIV.model.data.enhancedBet == 2) {
                reelStopAnimation.add(this.getRingGirlAndResultTL(i));
            }

            reelStopAnimation.add(() => BenjiKIV.allReelView.reelModels[i].doStop(reelData), "+=" + stopDelay);

            //Create split reel animation (if any)
            if(BenjiKIV.model.data.enhancedBet == 2) {
                if(BenjiKIV.model.data.enhancerReel[i] == 1) {
                    this._reelStoppedAnimations[i] = this.doSplitReel(i);
                }
            }

            //Add stop spin delay if previous reel has a reel stopped animation
            if(i > 0) {
                if(this._reelStoppedAnimations[i - 1].totalDuration() > 0) {
                    reelStopAnimation.delay(stopDelay + this._reelStoppedAnimations[i - 1].totalDuration() + 0.5);
                }
            }

            BenjiKIV.allReelView.reelModels[i].events?.once(SimpleReelModelState.STOPPED, (data:SimpleReelModelEventData) => this.onReelStop(data, this._controller));
            BenjiKIV.allReelView.reelModels[i].events?.once(SimpleReelModelState.BOUNCE, (data:SimpleReelModelEventData) => this.onReelBounce(data));

            this._tl.add(reelStopAnimation);
        }

        const padding:number = BenjiKIV.gameFlowController.calculatePaddingDuration(this._tl.totalDuration());
        if(padding > 0) {
            this._tl.delay((padding - 0.5));
        }
    }
}